import { CheckOutlined, CopyOutlined } from "@ant-design/icons"
import { useCopyToClipboard } from "../../hooks"
import { Button } from "antd"
type Props = { text: string; buttonProps?: React.ComponentProps<typeof Button> }

export function CopyToClipboardButton({ text, buttonProps }: Props) {
    const { copy, copied } = useCopyToClipboard()

    return (
        <Button
            type="text"
            size="small"
            icon={copied ? <CheckOutlined /> : <CopyOutlined />}
            onClick={() => copy(text)}
            style={{ color: copied ? "#52c41a" : "inherit" }}
            {...buttonProps}
        />
    )
}
